import React, { Component } from 'react';
import Cell from './Cell';
import { connect } from 'react-redux';
import _ from 'lodash';

class Trio extends Component {
  render() {
    const { cellWidth, hole, colors, style } = this.props;
    const cells = [new Cell(), new Cell(), new Cell(), new Cell()];

    cells[0].row = 1;
    cells[0].col = 1;

    cells[1].row = 1;
    cells[1].col = 2;

    cells[2].row = 2;
    cells[2].col = 1;

    cells[3].row = 2;
    cells[3].col = 2;

    return (
      <div
        style={{ display: 'grid', grid: 'auto auto / auto auto', justifyContent: 'center', ...style }}
        ref={el => {
          if (el) {
            this.rect = el.getBoundingClientRect();
          }
        }}
      >
        {_.map([0, 1, 2, 3], i => {
          const j = i - (i > hole ? 1 : 0);
          cells[i].color = colors[j];

          return (
            <span key={i}>
              {hole === i ? null : <Cell width={cellWidth} cell={cells[i]} shapes={this.props.shapes} />}
            </span>
          );
        })}
      </div>
    );
  }
}

function mapStateToProps({ tm, common }) {
  return { ...tm, ...common };
}

export default connect(
  mapStateToProps,
  {},
  null,
  { forwardRef: true }
)(Trio);
